import { render } from "./blog_evento.vue?vue&type=template&id=602d939a&scoped=true"
import script from "./blog_evento.vue?vue&type=script&lang=js"
export * from "./blog_evento.vue?vue&type=script&lang=js"

import "./blog_evento.vue?vue&type=style&index=0&id=602d939a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602d939a"]])

export default __exports__